import { Price } from "../types/Price";

export const formatPrice = (locale: string, price: Price) =>
  new Intl.NumberFormat(locale, {
    style: "currency",
    currency: price.currency,
  }).format(price.amount);
